import { sanitizeTrackDeepLinkUrl } from '../../pages/Track/trackDeviceId'

sanitizeTrackDeepLinkUrl()

/**
 * Public External Pages v1 routes (/track). Deep-link sanitization runs at module load.
 */
const ExternalPagesGate = ({ children }) => children

export default ExternalPagesGate
